module.exports = __webpack_public_path__ + "img/add.68f04e94.png";